import { FC } from 'react';
import {Box, Grid, styled, Typography } from '@mui/material';
import { MainTitle } from 'components/common/Title';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';

const Text = styled(Typography)(({ theme }) => ({
    fontStyle: 'normal',
    fontWeight: '600',
    // fontFamily: 'Open Sans',
    color: theme.palette.text.primary,
    fontSize: '20px',
    lineHeight: '26px',
    maxWidth: '100%',
    lineWidth: '500px',
    textWrap: 'wrap',
    textAlign: 'left',
    whiteSpace: "pre-line",
    // textWrap: 'wrap',
    wordBreak: 'break-word',
    // overflow: 'break-word',
    nowrap: false,
    // textOverflow: "ellipsis",
    // overflowWrap: 'break-word',
    // wordBreak: "break-word",
    [theme.breakpoints.up('xs')]: {
      fontSize: '16px',
    },
    [theme.breakpoints.up('sm')]: {
    },
  }));

interface Props {
    children?: React.ReactNode,
    data: any
}

const InfoBox: FC<Props> = ({ children, data, ...props }) => {
    return (
        <Box mt={4} gap='5px' display='flex' flexDirection='column' sx={{padding: '10px', width: '100%'}}>
            <MainTitle textAlign='left' padding='0' fontSizeXs='20px'>{data?.title}</MainTitle>
            <Grid container spacing={1} sx={{border: '0px solid red', padding: '5px'}}>
                <>{data?.boxes && data?.boxes
                .map((row: any) =>  
                    <Grid item md={6} xs={12}  sx={{ padding: '0px'}}>
                         <Box display='flex' flexDirection='column' gap='10px' sx={{border: '1px solid grey', padding: '10px', borderRadius: '5px'}}>
                            <Text>{row.title}</Text>
                            <>{row?.values && row?.values
                                .map((value: any) =>  
                                    <Text>- {value}</Text>
                            )}</> 
                         </Box>
                    </Grid>
                )}</> 
            </Grid>
        </Box>
    );
}

export { InfoBox };
